import { handleActions } from 'redux-actions';
import { CurrentLegAction, GO_TO_NEXT_LEG, SET_CURRENT_LEG } from './actions';

export const currentLegReducer = handleActions(
	{
		[SET_CURRENT_LEG]: (state, action: CurrentLegAction) => action.payload,
		[GO_TO_NEXT_LEG]: state => state + 1
	},
	0
);
